var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedoDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.47c-.01.28.21.5.49.51H.5c.26 0 .48-.21.5-.47v-.02c.04-1.3 5.4-7.14 11-7.48v4.49c0 .19.1.36.27.44.16.09.36.08.52-.03l11-7.5c.13-.09.21-.24.21-.41 0-.17-.08-.32-.22-.41l-11-7.5a.488.488 0 0 0-.52-.03C12.1.14 12 .31 12 .5v4.51C4.32 5.33.1 12.94 0 18.47Z",
    fill: "#44556B",
    style: {
      fill: "gray"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoDisabled);
export default __webpack_public_path__ + "static/media/redo-disabled.a131d2a9d351d4eb257e1aed339b70a6.svg";
export { ForwardRef as ReactComponent };